export const LOADING_TRUE = "loading/LOADING_TRUE";
export const LOADING_FALSE = "loading/LOADING_FALSE";
export const LOADING_TRUE2 = "loading/LOADING_TRUE2";
export const LOADING_FALSE2 = "loading/LOADING_FALSE2";
export const GLOBAL_LOADING_TRUE = "loading/GLOBAL_LOADING_TRUE";
export const GLOBAL_LOADING_FALSE = "loading/GLOBAL_LOADING_FALSE";
export const LOADING_DATA_TRUE = "loading/LOADING_DATA_TRUE";
export const LOADING_DATA_FALSE = "loading/LOADING_DATA_FALSE";